import { DocumentViewModule } from './document-view/document-view.module';
import { AddressSharedModule } from './shared/address-shared.module';
import { ClaimsModule } from './claims/claims.module';
import { AppSettingService } from './services/app-setting.service';
import { AuthenticationModule } from './authentication/authentication.module';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotFoundModule } from './not-found/not-found.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { SharedTranslateLazyModule, translateLoaderFactory } from './shared/shared-translate-lazy.module';
import { TranslateModule, TranslateLoader, TranslateStore, TranslateService } from '@ngx-translate/core';
import { CustomLoadingService } from './shared/custom-loading/custom-loading.service';
import { CommonUtilityModule } from './shared/common-utility.module';
import { LeftMenuModule } from './shared/left-menu.module';
import { ContactUsModule } from './contact-us/contact-us.module';
import { SettingsModule } from './settings/settings.module';
import { UrlSerializer } from '@angular/router';
import { LowerCaseUrlSerializerService } from './services/lower-case-url-serializer.service';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { ManagePracticeModule } from './manage-practice/Manage-Practice.module';
import { AvailabilityModule } from './availability/availability.module';
import { NgxMaskModule } from 'ngx-mask';
import { LicenseLiabilityResolverService } from './manage-practice/license-liability/license-liability-resolver.service';
import { AlertComponent } from './shared/toast/alert.component';

import { NotificationModule } from './notification/notification.module';
import { CoachinghubComponent } from './coachinghub/coachinghub.component';



@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    CoachinghubComponent
  ],
  imports: [
    NgxMaskModule.forRoot(),
    MatDialogModule,
    BrowserModule,
    AuthenticationModule,
    NotFoundModule,
    AppRoutingModule,
    ContactUsModule,
    SettingsModule,
    TranslateModule.forRoot({
      defaultLanguage:'en',
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: (translateLoaderFactory)
      }
    }),
    CommonUtilityModule,
    HttpClientModule,
    ClaimsModule,
    LeftMenuModule,
    NoopAnimationsModule ,
    ManagePracticeModule,
    AvailabilityModule,
    AddressSharedModule,
    BrowserAnimationsModule,
    DocumentViewModule,
    NotificationModule
  ],
  exports: [SharedTranslateLazyModule,CommonUtilityModule,AddressSharedModule],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializerService
    },
    TranslateStore,LicenseLiabilityResolverService,
    TranslateService,AppSettingService,CustomLoadingService
      
  ],
  bootstrap: [AppComponent]
})
export class AppModule {  static forRoot(): ModuleWithProviders {
  return {
    ngModule: AppModule,
    providers: [TranslateStore, TranslateService, AppSettingService]
  }
}}
